export const UPDATE = 'casino-heroes/regions/UPDATE'
